<template>
    <md-dialog :md-active.sync="show" class="paper-details">
        <md-dialog-title class="d-flex">
            Paper details
            <i class="material-icons ml-auto" @click="show = false">close</i>
        </md-dialog-title>

        <md-dialog-content v-if="currentPaper">
            <div class="speaker pb-3" v-if="!isSpeaker">
                <img
                    :src="currentPaper.speaker_photo_url"
                    alt="Speaker Photo"
                    class="speaker-photo"
                />
                <div class="speaker-name ml-sm-3 mt-2 mt-sm-0">
                    {{currentPaper.speaker_firstname}} {{currentPaper.speaker_lastname}}
                    <div>
                        <a
                            :href="'mailto:'+currentPaper.speaker_email"
                            target="_blank"
                        >{{currentPaper.speaker_email}}</a>
                    </div>
                    <!-- <div>
                        <strong>{{currentPaper.performed ? "The speaker has already performed this talk." : "This is the first time this speaker performs this talk."}}</strong>
                    </div>-->
                </div>
            </div>
            <span class="link-cospeakers" v-if="acceptedCospeakers.length" v-b-toggle.co-speakers>
                {{acceptedCospeakers.length}} co-speaker{{acceptedCospeakers.length > 1 ? "s" : ""}}
                <i
                    class="md-icon md-icon-font md-primary md-theme-default ml-2"
                >add</i>
            </span>
            <b-collapse id="co-speakers" class="mt-2">
                <span v-for="(speaker, index) in acceptedCospeakers" :key="index">
                    <a class="mb-2" :href="'mailto:'+speaker.email" target="blank">{{speaker.email}}</a>
                    {{index !== acceptedCospeakers.length - 1 && acceptedCospeakers.length !== 1 ? "-" : ""}}
                </span>
            </b-collapse>
            <div class="mt-3">
                <small class="pr-3 mb-3">TITLE</small>
                <h5 class="mb-3">{{paper.title}}</h5>
                <small class="pr-3 mb-3">ABSTRACT</small>
                <p>{{paper.abstract}}</p>

                <div class="d-flex flex-wrap mb-3">
                    <div class="w-lg-50 pr-lg-3">
                        <small class="pr-3">LENGTH</small>
                        <p>{{paper.length}} minutes</p>
                    </div>
                    <div class="w-lg-50 pl-lg-3 mt-3 mt-lg-0">
                        <small class="pr-3">SESSION TYPE</small>
                        <p>{{paper.session}}</p>
                    </div>
                </div>
                <div class="d-flex flex-wrap mb-3">
                    <div class="w-lg-50 pr-lg-3">
                        <small class="pr-3">FINANCIAL SUPPORT?</small>
                        <p v-if="!paper.refund">No</p>
                        <p
                            v-else-if="!isSpeaker"
                        >The speaker needs financial support to attend the meetup.</p>
                        <p v-else>Yes</p>
                    </div>
                    <div class="w-lg-50 pl-lg-3 mt-3 mt-lg-0">
                        <small class="pr-3">LEVEL</small>
                        <p>{{paper.level}}</p>
                    </div>
                </div>

                <div class="d-flex flex-wrap mb-3">
                    <div class="w-lg-50 pr-lg-3">
                        <small class="pr-3">TECHNICAL AND LOGISTICAL REQUIREMENTS</small>
                        <p>{{paper.requirements || "None"}}</p>
                    </div>
                    <div class="w-lg-50 pl-lg-3 mt-3 mt-lg-0">
                        <small class="pr-3">NOTES</small>
                        <p>{{paper.notes || "None"}}</p>
                    </div>
                </div>
            </div>
        </md-dialog-content>
        <div
            v-if="currentPaper"
            class="w-100 text-right py-3 px-3 modal-footer"
            :class="{'justify-content-start': agenda}"
        >
            <div
                class="d-flex d-lg-none align-items-center mt-3 back mt-auto link"
                v-if="agenda"
                @click="show = false"
            >
                <i class="material-icons mr-2">chevron_left</i>Back to papers
            </div>
            <a :href="`//events.codemotion.com/call-for-speakers/${currentPaper.cfp_slug}`">
                <button
                    class="btn btn-primary"
                    v-if="(!approvable || (approvable && currentPaper.state !== 'WAITING_FOR_APPROVAL')) && !agenda"
                >View CFS</button>
                <span v-else-if="!agenda">View CFS</span>
            </a>
            <button
                class="btn btn-outline-success"
                v-if="approvable && currentPaper.state === 'WAITING_FOR_APPROVAL'"
                @click="reject(currentPaper)"
            >reject</button>
            <button
                class="btn btn-primary"
                v-if="approvable && currentPaper.state === 'WAITING_FOR_APPROVAL'"
                @click="approve(currentPaper)"
            >approve</button>
        </div>
        <md-dialog-alert
            :md-active.sync="errorsDialog"
            :md-content="errorMsg"
            :md-backdrop="false"
            class="error-dialog"
        ></md-dialog-alert>
    </md-dialog>
</template>
<script>
import { validationMixin } from "vuelidate";
import {
    required,
    minLength,
    maxLength,
    minValue,
    email,
    sameAs
} from "vuelidate/lib/validators";
import {
    isoCountries,
    isoLanguages,
    isoNationalities,
    getCountryCode
} from "@/services/utils";
export default {
    name: "PaperInfoModal",
    mixins: [validationMixin],
    props: [
        "value",
        "currentPaper",
        "isSpeaker",
        "approvable",
        "approve",
        "reject",
        "agenda"
    ],
    async mounted() {
        if (this.currentPaper) {
            this.paper = {
                ...this.paper,
                title: this.currentPaper.title,
                abstract: this.currentPaper.abstract,
                tags: this.currentPaper.tags || [],
                language: isoLanguages[this.currentPaper.language],
                level: this.levelData[this.currentPaper.level],
                length: this.currentPaper.duration,
                session: this.sessionTypeData[this.currentPaper.session_type],
                coSpeaker: this.currentPaper.coSpeaker || [],
                requirements: this.currentPaper.needs || "",
                notes: this.currentPaper.note || "",
                refund: this.currentPaper.refund
                // performed: this.currentPaper.performed
            };
        }
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        },
        acceptedCospeakers() {
            if (this.currentPaper.cospeakers)
                return this.currentPaper.cospeakers.filter(
                    el => el.state !== "REFUSED"
                );
            return [];
        }
        // countries() {
        //     return Object.values(isoCountries);
        // },
        // languages() {
        //     return Object.values(isoLanguages);
        // },
        // nationalities() {
        //     return Object.values(isoNationalities);
        // },
        // topics() {
        //     return this.cfp.topics.map(el => " " + el.name);
        // },
        // lengths() {
        //     return [...this.cfp.lengths];
        // }
    },
    data: () => ({
        paper: {
            title: "",
            abstract: "",
            level: null,
            length: null,
            // performed: null,
            session: null,
            coSpeaker: [],
            requirements: "",
            notes: "",
            refund: null,
            consent: false,
            language: "",
            tags: []
        },
        levelData: {
            FOR_EVERYONE: "Non technical/for everyone",
            BEGINNER: "Beginner",
            INTERMEDIATE: "Intermediate",
            ADVANCED: "Advanced"
        },
        sessionTypeData: {
            LIGHTNING: "Lightning",
            TALK: "Talk",
            WORKSHOP: "Workshop",
            LIVE_CODING: "Live code",
            HANDS_ON: "Hands-on"
        },
        errorsDialog: false,
        errorMsg: "",
        loading: true
    })
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_common.scss";
.error-dialog {
    z-index: 5000 !important;
}

.w-lg-50 {
    width: 100%;
    @media all and (min-width: 991px) {
        width: 50%;
    }
}
.paper-details {
    @media all and (min-width: 600px) {
        width: 90%;
    }
    max-width: 1000px;

    .md-dialog-title i {
        cursor: pointer;
    }
    .speaker {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .speaker-photo {
            width: 90px;
            border-radius: 50%;
        }
        .speaker-name {
            @media all and (max-width: $size-tablet-portrait) {
                width: 100%;
            }
        }
    }
    p,
    h5 {
        color: $palette-blue;
        font-size: 16px;
    }
    .modal-footer {
        border-top: 1px solid #eaeaea;
    }
}
.actions-container {
    button {
        width: 100%;
        @media all and (min-width: $size-tablet-portrait) {
            width: 48%;
        }
    }
}
.radio-box {
    display: flex;
    flex-wrap: wrap;
    padding: 20px;
    align-items: center;
    // justify-content: center;
    border-radius: 5px;
    border: solid 1px #e4e4ea;
    margin-bottom: 30px;
    h6 {
        font-weight: 600;
        margin: 0;
        strong {
            display: inline !important;
            font-size: 20px;
        }
    }
    div {
        width: 100%;
    }
    .md-radio {
        margin-bottom: 0;
    }
    @media all and (min-width: $size-tablet-landscape) {
        div {
            width: auto;
        }
        .md-radio {
            margin-top: 0;
        }
    }
    .text-danger {
        display: none;
    }
    &.md-invalid {
        .text-danger {
            display: block;
        }
        border: solid 1px red;
    }
}
.alert-box {
    background: $palette-blue;
    border-radius: 5px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    .md-icon {
        color: white !important;
    }
}
.form-block {
    padding-bottom: 10px;
    h6 {
        color: $palette-blue;
        font-weight: 600;
        margin: 0;
        strong {
            font-size: 20px;
        }
    }
    @media all and (min-width: $size-tablet-landscape) {
        margin-bottom: 20px;
        display: flex;
        h6 {
            padding-right: 10px;
            border-right: 1px solid #e4e4ea;
            width: 25%;
        }
        .fields {
            width: 75%;
            padding: 0 0 15px 35px;
        }
    }
}
.add-field {
    color: $palette-orange;
    transition: all 0.5s ease;
    cursor: pointer;
    margin-top: 10px;
    &:hover {
        color: $palette-dark-orange;
    }
}
// .md-has-textarea {
//     &::after {
//         border-color: #9b9b9b!important;
//     }
// }
.instructions {
    border-radius: 5px;
    padding: 5px 10px;
    margin-left: 15px;
    background: #97979797;
    font-weight: bolder;
    color: white;
    max-width: 120px;
    &.text-danger {
        background: transparent;
        border: 1px solid red;
        display: none;
        font-weight: 500;
        text-align: center;
    }
    &.md-invalid {
        display: block;
    }
    @media all and (min-width: $size-tablet-landscape) {
        max-width: 180px;
        &.text-danger {
            text-align: left;
        }
    }
}
.back {
    i {
        border-radius: 50%;
        padding: 5px;
        background: #f8f8f8;
    }
}
.photo {
    position: relative;
    width: 155px;

    img {
        width: 100%;
        border: 2px dashed #979797;
        border-radius: 50%;
        margin-bottom: 10px;
    }
    i {
        position: absolute;
        top: 15px;
        right: 15px;
        font-size: 24px;
        border-radius: 50%;
        padding: 3px;
        cursor: pointer;
        background: white;
        color: $palette-orange;
        transition: all 0.5s ease;
        &:hover {
            background: lightgray;
        }
    }
}
</style>
<style lang="scss">
@import "@/assets/scss/_common.scss";
.md-list-item-text {
    text-transform: capitalize;
}
.v-note-wrapper {
    z-index: 5 !important;
    min-width: 240px !important;
    &.md-invalid {
        border: 2px solid red;
    }
}

.link-cospeakers {
    cursor: pointer;
    i {
        background-color: #f8f8f8;
        border-radius: 10px;
    }
    &:hover {
        i {
            background-color: #d8d8d8;
        }
    }
}
.op-image.popup-dropdown .dropdown-item:last-of-type {
    display: none;
}
.md-dialog-actions {
    justify-content: center;
    padding: 8px;
}
.md-menu-content-bottom-start {
    max-height: 25vh;
}
.md-menu-content {
    z-index: 1041 !important;
}
.cfp-form {
    .md-chip {
        background: #f5f5f5 !important;
        color: $palette-blue !important;
        button {
            background: #f5f5f5 !important;

            i {
                padding: 0 !important;
                svg {
                    fill: $palette-blue !important;
                }
            }
        }
    }

    .delete {
        cursor: pointer;
        color: #0000008a;
    }

    .md-radio-label {
        margin: 0;
    }
    .md-checkbox {
        label {
            height: auto !important;
        }
        &.md-invalid {
            color: red;
        }
    }
}
</style>